// @flow
import React, { Component } from "react";
import ReactModal from "react-modal";

import { THEME_RED } from "../../commons/theme";
import { createOrder } from "../../api/orders";

import type { Order } from "../catalog";
import Form from "./Form";

type Props = {
  total: number,
  order: Order,
  onCancelOrder: () => any
};

type State = {
  name: string,
  email: string,
  tel: string,

  flow: "FORM" | "BUSY" | "OK" | "KO"
};

class OrderCompletion extends Component<Props, State> {
  state = {
    name: "",
    email: "",
    tel: "",

    flow: "FORM"
  };

  componentDidMount() {
    if (this.props.total <= 0) {
      location.hash = ""; // eslint-disable-line
    }
  }

  onClickConfirm = async () => {
    const { order } = this.props;
    const { name, email, tel } = this.state;

    const validEmail = email && email.match(/.+@.+\..+/);
    if (!name || (!validEmail && !tel)) {
      alert("Votre nom et un moyen de contact valide sont requis");
      return;
    }

    this.setState({ flow: "BUSY" });

    const items = {};
    Object.keys(order).forEach(bottleName => {
      Object.keys(order[bottleName]).forEach(bottleType => {
        const qty = order[bottleName][bottleType];
        if (qty > 0) {
          items[`${bottleName} - ${bottleType}`] = qty;
        }
      });
    });

    const result = await createOrder({
      name,
      email,
      tel,
      items
    });

    if (result) {
      this.setState({ flow: "OK" });
    } else {
      this.setState({ flow: "KO" });
    }
  };

  onChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const id = e.currentTarget.dataset.id;
    this.setState({ [id]: e.currentTarget.value });
  };

  render() {
    const { name, email, tel, flow } = this.state;

    return (
      <ReactModal
        isOpen
        onRequestClose={this.props.onCancelOrder}
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        style={{
          overlay: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          content: {
            position: "static",
            background: "#17161b",
            color: "#FFF",
            margin: 0,
            top: "auto",
            bottom: "auto",
            left: "auto",
            right: "auto",
            maxWidth: 500,
            maxHeight: "calc(100vh - 50px)"
          }
        }}
      >
        <h3>Commande</h3>

        {flow === "FORM" && (
          <Form
            name={name}
            email={email}
            tel={tel}
            onChange={this.onChange}
            onClickConfirm={this.onClickConfirm}
          />
        )}

        {flow === "BUSY" && <div>Envoi en cours...</div>}

        {flow === "KO" && (
          <div style={{ color: THEME_RED }}>
            Une erreur s'est produite pendant la prise de commande<br />
            Veuillez nous contacter directement par e-mail ou téléphone
          </div>
        )}

        {flow === "OK" && (
          <div>
            La commande a bien été prise en compte.<br />
            Vous serez recontacté dans les plus brefs délais pour confirmation
            et prise de détail de livraison.
          </div>
        )}
      </ReactModal>
    );
  }
}

export default OrderCompletion;



// WEBPACK FOOTER //
// ./src/NosBouteilles/OrderCompletion/index.js